import React from "react";
import { Zap } from "lucide-react";
import SacredChatPage from "./SacredChatPage";
import { PLAYLISTS } from "@/lib/tracks";

export default function Zeus() {
  return (
    <SacredChatPage
      persona="zeus"
      personaLabel="Zeus"
      IconComponent={Zap}
      accent="#ffd84a"
      theme={{
        bgRadial: "radial-gradient(ellipse at top, #2a1a04 0%, #1a0e02 55%, #050300 100%)",
        fg: "#fff8d8",
        msgBg: "linear-gradient(180deg, rgba(32,20,4,0.94), rgba(8,4,0,0.96))",
        msgFg: "#f8dc8c",
      }}
      title={{
        fr: <><span className="italic" style={{ color: "#ffd84a" }}>Zeus</span>, Roi de l'Olympe.</>,
        en: <><span className="italic" style={{ color: "#ffd84a" }}>Zeus</span>, King of Olympus.</>,
      }}
      subtitle={{
        fr: "⚡ Père des dieux et des hommes, maître de la foudre. Je bouscule la tiédeur par mes questions, sans jamais rien t'ordonner. Foudroyant, mais bienveillant. À la fin, c'est TOI qui choisis.",
        en: "⚡ Father of gods and men, master of thunder. I shake lukewarmness with my questions, never ordering you. Thunderous, yet benevolent. In the end, YOU choose.",
      }}
      greeting={{
        fr: "« Parle, mortel. Mais ne me fais pas perdre mon temps avec des pleurnicheries. »",
        en: "\"Speak, mortal. But do not waste my time with whining.\"",
      }}
      suggestions={{
        fr: [
          "Je suis tiède, je ne sais pas quoi faire de ma vie.",
          "Comment affronter une peur que j'évite depuis des mois ?",
          "Je dois couper un lien toxique mais j'hésite.",
          "Qu'est-ce que le courage, selon toi ?",
        ],
        en: [
          "I'm lukewarm, I don't know what to do with my life.",
          "How to face a fear I've avoided for months?",
          "I need to cut a toxic bond but I hesitate.",
          "What is courage, according to you?",
        ],
      }}
      playlist={PLAYLISTS.zeus}
      replySound={`${process.env.REACT_APP_BACKEND_URL}/api/static/audio/zeus_thunder.mp3`}
      sfxEmoji="⚡"
      sfxLabel={{ fr: "la foudre", en: "thunder" }}
    />
  );
}
